import React from "react";
import { observer } from "mobx-react-lite";
import { useApp } from "../context";
import { Button, makeStyles, Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  padding: {
    padding: theme.spacing(2),
  },
  marginBottom: {
    marginBottom: theme.spacing(2),
  },
  downloadButton: {
    // float: "right",
  },
}));

export const AdminContactsRoute = observer(function AdminContactsRoute() {
  const app = useApp();
  const classes = useStyles();
  const { t } = useTranslation();

  // TODO: Check auth/permission

  return (
    <div className={classes.padding}>
      <Typography variant="h5" component="h2" className={classes.marginBottom}>
        {t("admin-contacts")}
      </Typography>
      <Typography variant="body1" className={classes.marginBottom}>
        {t("contact-export-message")}
      </Typography>
      <Button
        variant="contained"
        size="small"
        color="primary"
        className={classes.downloadButton}
        onClick={() => {
          app.admin.downloadContacts();
        }}
      >
        {t("button-download")}
      </Button>
    </div>
  );
});
